import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getPromoImages } from '../../helpers/promotions.ts';

import css from './Header.module.scss';

const Header = props => {
  const { backTo, setNextRegStep, location, promotionId, partner } = props;
  const { pathname } = location;
  const headerLogo =
    getPromoImages(promotionId).headerLogoImage ??
    `/static/gl-logo-next-gen.svg`;

  const showBackButton =
    !!backTo && !(partner === 'MSB' && pathname === '/confirm-code');
  const showSsl = pathname !== '/complete' && pathname !== '/';

  return (
    <div className={css.AppHeader} data-testid="header">
      {showBackButton ? (
        <Link
          className={css.backButton}
          to={backTo.url || '/'}
          onClick={() => setNextRegStep(backTo.nextRegStep)}
          data-testid="back-button"
        >
          <img
            className={css.backDesktop}
            src="/static/back-arrow.svg"
            alt="Back Button"
          />
          <img
            className={css.backMobile}
            src="/static/back-arrow-mobile.svg"
            alt="Back Button"
          />
        </Link>
      ) : (
        <div style={{ width: '24px' }} />
      )}
      <img src={headerLogo} className={css.headerLogo} alt="Greenlight Logo" />
      {showSsl ? (
        <img
          className={css.AppSecure}
          src="/static/logo-ssl.png"
          alt="SSL Secure"
          data-testid="ssl-image"
        />
      ) : (
        <div />
      )}
    </div>
  );
};

Header.propTypes = {
  backTo: PropTypes.shape({
    url: PropTypes.string,
    nextRegStep: PropTypes.string
  }),
  setNextRegStep: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  })
};

export default Header;
